import axios, { AxiosPromise } from 'axios';
import { IAkcionar, ISezhlasovani } from 'types/akcionar';

import { EStavHl } from 'enums/akcionarKorpAkce/stavHl';

import { IHromadneHlasovaniUctyInput } from './hromadneHlasovani';

export interface IHlasovaniTableData {
    offset: number;
    limit: number;
    count: number;
    order: string;
    uctyudalosti?: IUctyUdalosti[];
}

export interface IUctyUdalosti {
    oid: number;
    cdac: string;
    rcma: string;
    nazev: string;
    pocet: number;
    stavhl: EStavHl;
}

export const hlasovaniSpravcePut = (id: string, oid: string, body: ISezhlasovani): AxiosPromise => {
    return axios({
        method: 'PUT',
        url: `/Spravceuctu/${id}/${oid}/`,
        data: body
    });
};

export const hlasovaniSpravcePost = (id: string, oid: string, body: ISezhlasovani): AxiosPromise => {
    return axios({
        method: 'POST',
        url: `/Spravceuctu/${id}/${oid}/`,
        data: body
    });
};

export const hlasovaniSpravceGet = (id: string, oid: string): AxiosPromise<IAkcionar> => {
    return axios({
        method: 'GET',
        url: `/Spravceuctu/${id}/${oid}/`
    });
};

export const hlasovaniTableDataApi = (
    id: number,
    pagination: IHromadneHlasovaniUctyInput
): AxiosPromise<IHlasovaniTableData> => {
    return axios({
        method: 'GET',
        url: `/Spravceuctu/${id}/`,
        params: pagination
    });
};
